module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAYAAAB24g05AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABXSURBVHgBpZBdDQAgCIQvihGMYGMjGMEIRjACyoaPTH5uYzxwH4MDgiKicqsjIoEHd3gl8MzCFV6psPxSQ/B3COPZmsn1M5turWcOBSZLGGqZtHnJtsIHLc2YCgy1QJkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/checkW.png
// module id = 607
// module chunks = 0